import { render, staticRenderFns } from "./TemplatesSelection.vue?vue&type=template&id=27e43a70"
import script from "./TemplatesSelection.vue?vue&type=script&lang=js"
export * from "./TemplatesSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports